const files = require.context("./modules", false, /[A-Za-z]+.js/);
let routes = [];
files.keys().forEach(route => {
  const routeModule = files(route);
  routes = [...routes, ...(routeModule.default || routeModule)];
});

export default routes;